<template>
  <v-form class="search-filter">
    <v-row class="px-4 px-sm-7 py-7">
      <v-col class="col-6 col-md-3 pa-0 pr-4 mb-2">
        <v-text-field
          v-model="purOrgName"
          label="代理机构"
          dense
          outlined
          clearable
        ></v-text-field>
      </v-col>
      <v-col class="col-6 col-md-3 pa-0 pr-md-4 mb-2">
        <v-text-field
          v-model="messageTitle"
          label="项目名称"
          dense
          outlined
          clearable
        ></v-text-field>
      </v-col>
      <v-col class="col-6 col-md-3 pa-0 pr-4 mb-md-2">
        <v-menu
          v-model="startTimeMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startTime"
              label="请选择开始日期"
              dense
              outlined
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startTime"
            @input="startTimeMenu = false"
            locale="zh-cn"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col class="col-6 col-md-3 pa-0 mb-md-2">
        <v-menu
          v-model="endTimeMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endTime"
              label="请选择结束日期"
              dense
              outlined
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endTime"
            @input="endTimeMenu = false"
            locale="zh-cn"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col class="col-12 pa-0 d-flex justify-center justify-md-end align-center">
        <v-btn class="mr-4" color="error" width="100" @click="reset">重置</v-btn>
        <v-btn class="mr-4" color="primary" width="100" @click="submit">查询</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>

export default {
  name: 'SearchFilter',
  data: () => ({
    purOrgName: '',
    messageTitle: '',
    startTime: null,
    endTime: null,
    startTimeMenu: false,
    endTimeMenu: false,
    items: [{
      id: 0,
      text: 'item1'
    }, {
      id: 1,
      text: 'item2'
    }, {
      id: 2,
      text: 'item3'
    }, {
      id: 3,
      text: 'item4'
    }]
  }),
  methods: {
    addZeroString (number) {
      if (number < 10) {
        return `0${number}`
      }
      return number
    },
    generateDate (date) {
      const year = date.getFullYear()
      const mounth = date.getMonth() + 1
      const day = date.getDate()
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const seconds = date.getSeconds()
      return `${year}-${mounth}-${day} ${this.addZeroString(hours)}:${this.addZeroString(minutes)}:${this.addZeroString(seconds)}`
    },
    submit () {
      let startPublishTime = null
      let endPublishTime = null
      let startTime = null
      let endTime = null
      if (this.startTime) {
        startPublishTime = new Date(this.startTime)
        startPublishTime.setHours(0)
        startPublishTime = this.generateDate(startPublishTime)

        startTime = new Date(this.startTime)
        startTime.setHours(0)
        startTime = this.generateDate(startTime)
      }
      if (this.endTime) {
        endPublishTime = new Date(this.endTime)
        endPublishTime.setDate(endPublishTime.getDate() + 1)
        endPublishTime.setHours(0)
        endPublishTime = this.generateDate(endPublishTime)

        endTime = new Date(this.endTime)
        endTime.setDate(endTime.getDate() + 1)
        endTime.setHours(0)
        endTime = this.generateDate(endTime)
      }
      this.$gemit('searchFilterSubmit', {
        messageTitle: this.messageTitle,
        purOrgName: this.purOrgName,
        startPublishTime,
        endPublishTime,
        startTime,
        endTime
      })
    },
    reset () {
      this.startTime = null
      this.endTime = null
      this.purOrgName = ''
      this.messageTitle = ''
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
